<!--
    Summary:
        首页
    ChangeLog:
        Labbor on 2020/2/21 added
-->
<template>
  <div class="v-home">
    <div class="banners no-select">
      <el-carousel @change="onBannerChange" trigger="click" :autoplay="true" indicator-position="none">
        <!-- <el-carousel-item>
          <img class="banner-img" src="../assets/images/home/dragonBoatFestival.jpg"/>
         </el-carousel-item> -->
        <el-carousel-item>
          <img class="banner-img" src="../assets/images/home/Mainslide_1920x960_012020-06.jpg"/>
         </el-carousel-item>
        

        <el-carousel-item>
          <img class="banner-img" src="../assets/images/home/Mainslide_1920x960_012020-03.jpg"/>
          <div class="banner-tip-wrapper">
          <div class="banner-tip">
            <!-- 上下拉动 -->
            <div class="pull">


              <!-- LAYER NR. 15 -->
              <div class="tp-parallax-wrap" style="position: absolute; display: block; visibility: visible; left: 202px; top: 156px; z-index: 11;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption very_large_text   tp-resizeme" id="slide-12-layer-24" data-x="['center','center','center','center']" data-hoffset="['-455','-447','-336','-195']" data-y="['top','top','top','top']" data-voffset="['77','93','57','212']" data-fontsize="['70','70','45','45']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:670,&quot;speed&quot;:700,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power4.easeInOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['right','right','right','right']" data-paddingtop="[27,27,12,7]" data-paddingright="[20,20,20,17]" data-paddingbottom="[27,27,12,7]" data-paddingleft="[20,20,20,17]" style="z-index: 11; white-space: nowrap; font-size: 70px; letter-spacing: 0px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; background-color: rgb(0, 176, 192); border-radius: 80px; visibility: inherit; transition: none 0s ease 0s; text-align: right; line-height: 60px; border-width: 0px; margin: 0px; padding: 27px 20px; font-weight: 700; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_2_1')}} </div></div></div></div>

              <!-- LAYER NR. 16 -->
              <div class="tp-parallax-wrap" style="position: absolute; display: block; visibility: visible; left: 291px; top: 176px; z-index: 12;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption very_large_text   tp-resizeme" id="slide-12-layer-25" data-x="['center','center','center','center']" data-hoffset="['-366','-359','-269','-135']" data-y="['top','top','top','top']" data-voffset="['97','124','71','212']" data-fontsize="['70','70','45','45']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:720,&quot;speed&quot;:700,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power4.easeInOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['center','center','center','right']" data-paddingtop="[27,27,12,7]" data-paddingright="[20,20,20,17]" data-paddingbottom="[27,27,12,7]" data-paddingleft="[20,20,20,17]" style="z-index: 12; white-space: nowrap; font-size: 70px; letter-spacing: 0px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; background-color: rgb(95, 208, 223); border-radius: 80px; visibility: inherit; transition: none 0s ease 0s; text-align: center; line-height: 60px; border-width: 0px; margin: 0px; padding: 27px 20px; font-weight: 700; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_2_2')}} </div></div></div></div>

              <!-- LAYER NR. 17 -->
              <div class="tp-parallax-wrap" style="position: absolute; display: block; visibility: visible; left: 381px; top: 137px; z-index: 13;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption very_large_text   tp-resizeme" id="slide-12-layer-26" data-x="['center','center','center','center']" data-hoffset="['-276','-268','-197','-75']" data-y="['top','top','top','top']" data-voffset="['58','73','43','214']" data-fontsize="['70','70','45','45']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:770,&quot;speed&quot;:700,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power4.easeInOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['center','center','center','center']" data-paddingtop="[27,27,12,7]" data-paddingright="[20,20,20,17]" data-paddingbottom="[27,27,17,7]" data-paddingleft="[20,20,20,17]" style="z-index: 13; white-space: nowrap; font-size: 70px; letter-spacing: 0px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; background-color: rgb(0, 138, 171); border-radius: 80px; visibility: inherit; transition: none 0s ease 0s; text-align: center; line-height: 60px; border-width: 0px; margin: 0px; padding: 27px 20px; font-weight: 700; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_2_3')}} </div></div></div></div>

              <!-- LAYER NR. 18 -->
              <div class="tp-parallax-wrap" style="position: absolute; display: block; visibility: visible; left: 466px; top: 157px; z-index: 14;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption very_large_text   tp-resizeme" id="slide-12-layer-27" data-x="['center','center','center','center']" data-hoffset="['-191','-183','-131','-15']" data-y="['top','top','top','top']" data-voffset="['78','93','73','214']" data-fontsize="['70','70','40','45']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:820,&quot;speed&quot;:700,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power4.easeInOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['center','center','center','center']" data-paddingtop="[27,27,12,7]" data-paddingright="[20,20,20,17]" data-paddingbottom="[27,27,12,7]" data-paddingleft="[20,20,20,17]" style="z-index: 14; white-space: nowrap; font-size: 70px; letter-spacing: 0px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; background-color: rgb(0, 176, 192); border-radius: 80px; visibility: inherit; transition: none 0s ease 0s; text-align: center; line-height: 60px; border-width: 0px; margin: 0px; padding: 27px 20px; font-weight: 700; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_2_4')}} </div></div></div></div>

              <!-- LAYER NR. 11 -->
              <div class="tp-parallax-wrap" style="position: absolute; display: block; visibility: visible; left: 842px; top: 134px; z-index: 7;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption very_large_text   tp-resizeme" id="slide-12-layer-4" data-x="['center','center','center','center']" data-hoffset="['185','188','131','14']" data-y="['top','top','top','top']" data-voffset="['55','119','42','292']" data-fontsize="['70','70','45','45']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:670,&quot;speed&quot;:700,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power4.easeInOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['right','right','right','right']" data-paddingtop="[27,27,12,7]" data-paddingright="[20,20,20,17]" data-paddingbottom="[27,27,12,7]" data-paddingleft="[20,20,20,17]" style="z-index: 7; white-space: nowrap; font-size: 70px; letter-spacing: 0px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; background-color: rgb(0, 176, 192); border-radius: 80px; visibility: inherit; transition: none 0s ease 0s; text-align: right; line-height: 60px; border-width: 0px; margin: 0px; padding: 27px 20px; font-weight: 700; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_2_5')}} </div></div></div></div>

              <!-- LAYER NR. 12 -->
              <div class="tp-parallax-wrap" style="position: absolute; display: block; visibility: visible; left: 931px; top: 153px; z-index: 8;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption very_large_text   tp-resizeme" id="slide-12-layer-20" data-x="['center','center','center','center']" data-hoffset="['274','272','202','74']" data-y="['top','top','top','top']" data-voffset="['74','86','56','291']" data-fontsize="['70','70','45','45']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:720,&quot;speed&quot;:700,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power4.easeInOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['center','center','center','right']" data-paddingtop="[27,27,12,7]" data-paddingright="[20,20,20,17]" data-paddingbottom="[27,27,12,7]" data-paddingleft="[20,20,20,17]" style="z-index: 8; white-space: nowrap; font-size: 70px; letter-spacing: 0px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; background-color: rgb(0, 138, 171); border-radius: 80px; visibility: inherit; transition: none 0s ease 0s; text-align: center; line-height: 60px; border-width: 0px; margin: 0px; padding: 27px 20px; font-weight: 700; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_2_6')}} </div></div></div></div>

              <!-- LAYER NR. 13 -->
              <div class="tp-parallax-wrap" style="position: absolute; display: block; visibility: visible; left: 1021px; top: 174px; z-index: 9;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption very_large_text   tp-resizeme" id="slide-12-layer-21" data-x="['center','center','center','center']" data-hoffset="['364','362','267','135']" data-y="['top','top','top','top']" data-voffset="['95','116','76','291']" data-fontsize="['70','70','45','45']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:770,&quot;speed&quot;:700,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power4.easeInOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['center','center','center','center']" data-paddingtop="[27,27,12,7]" data-paddingright="[20,20,20,17]" data-paddingbottom="[27,27,12,7]" data-paddingleft="[20,20,20,17]" style="z-index: 9; white-space: nowrap; font-size: 70px; letter-spacing: 0px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; background-color: rgb(0, 176, 192); border-radius: 80px; visibility: inherit; transition: none 0s ease 0s; text-align: center; line-height: 60px; border-width: 0px; margin: 0px; padding: 27px 20px; font-weight: 700; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_2_7')}} </div></div></div></div>

              <!-- LAYER NR. 14 -->
              <div class="tp-parallax-wrap" style="position: absolute; display: block; visibility: visible; left: 1106px; top: 154px; z-index: 10;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption very_large_text   tp-resizeme" id="slide-12-layer-22" data-x="['center','center','center','center']" data-hoffset="['449','448','337','194']" data-y="['top','top','top','top']" data-voffset="['75','86','57','291']" data-fontsize="['70','70','45','45']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:820,&quot;speed&quot;:700,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power4.easeInOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['center','center','center','center']" data-paddingtop="[27,27,12,7]" data-paddingright="[20,20,20,17]" data-paddingbottom="[27,27,12,7]" data-paddingleft="[20,20,20,17]" style="z-index: 10; white-space: nowrap; font-size: 70px; letter-spacing: 0px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; background-color: rgb(95, 208, 223); border-radius: 80px; visibility: inherit; transition: none 0s ease 0s; text-align: center; line-height: 60px; border-width: 0px; margin: 0px; padding: 27px 20px; font-weight: 700; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_2_8')}} </div></div></div></div>

            </div>
            <!-- 左右滑动 -->
            <div class="slide">
              <!-- LAYER NR. 10 -->
              <div class="tp-parallax-wrap-line left" style="position: absolute; display: block; visibility: visible; left: 93px; top: 343px; z-index: 6;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption Gym-Subline   tp-resizeme" id="slide-12-layer-13" data-x="['left','left','left','left']" data-hoffset="['1','1','168','137']" data-y="['top','top','top','top']" data-voffset="['264','324','300','503']" data-fontsize="['45','40','35','30']" data-letterspacing="['16','12','3','7']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:670,&quot;speed&quot;:1500,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;x:[-175%];y:0px;z:0;rX:0;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:1;&quot;,&quot;to&quot;:&quot;o:1;skX:-10px;&quot;,&quot;ease&quot;:&quot;Power3.easeOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['right','right','right','right']" data-paddingtop="[20,10,20,7]" data-paddingright="[20,20,20,20]" data-paddingbottom="[20,10,20,7]" data-paddingleft="[25,25,25,20]" style="z-index: 6; white-space: nowrap; font-size: 45px; color: rgb(255, 255, 255); letter-spacing: 16px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; background-color: rgb(0, 176, 192); font-weight: 600; visibility: inherit; transition: none 0s ease 0s; text-align: right; line-height: 30px; border-width: 0px; margin: 0px; padding: 20px 20px 20px 25px; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, -0.173648, 0.984808, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_2_Left')}} </div></div></div></div>

              <!-- LAYER NR. 9 -->
              <div class="tp-parallax-wrap-line right" style="position: absolute; display: block; visibility: visible; top: 343px; z-index: 5;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption Gym-Subline   tp-resizeme" id="slide-12-layer-5" data-x="['left','left','left','left']" data-hoffset="['826','667','306','204']" data-y="['top','top','top','top']" data-voffset="['264','323','377','546']" data-fontsize="['45','40','35','30']" data-letterspacing="['16','12','3','7']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:670,&quot;speed&quot;:1500,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;x:[175%];y:0px;z:0;rX:0;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:1;&quot;,&quot;to&quot;:&quot;o:1;skX:10px;&quot;,&quot;ease&quot;:&quot;Power3.easeOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['right','right','right','right']" data-paddingtop="[20,10,20,7]" data-paddingright="[20,20,20,20]" data-paddingbottom="[20,10,20,7]" data-paddingleft="[25,25,25,25]" style="z-index: 5; white-space: nowrap; font-size: 45px; color: rgb(255, 255, 255); letter-spacing: 16px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; background-color: rgb(0, 138, 171); font-weight: 600; visibility: inherit; transition: none 0s ease 0s; text-align: right; line-height: 30px; border-width: 0px; margin: 0px; padding: 20px 20px 20px 25px; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0.173648, 0.984808, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_2_Right')}} </div></div></div></div>
            </div>
          </div>
          </div>
         </el-carousel-item>
        <el-carousel-item>
          <img class="banner-img" src="../assets/images/home/Mainslide_1920x960_012020-04.jpg"/>
          <div class="banner-tip-wrapper">
          <div class="banner-tip">
            <!-- 上下拉动 -->
            <div class="pull">
              <!-- LAYER NR. 19 -->
              <div class="tp-parallax-wrap " style="position: absolute; display: block; visibility: visible; left: 367px; top: 79px; z-index: 6;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption very_large_text   tp-resizeme" id="slide-14-layer-15" data-x="['center','center','center','center']" data-hoffset="['0','0','0','0']" data-y="['top','top','top','top']" data-voffset="['0','3','2','482']" data-fontsize="['45','45','40','30']" data-fontweight="['400','400','400','700']" data-letterspacing="['10','10','4','3']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:400,&quot;speed&quot;:1000,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power4.easeInOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['center','center','center','center']" data-paddingtop="[0,0,0,0]" data-paddingright="[0,0,0,0]" data-paddingbottom="[0,0,0,0]" data-paddingleft="[0,0,0,0]" style="z-index: 6; white-space: nowrap; font-size: 45px; font-weight: 400; letter-spacing: 10px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; visibility: inherit; transition: none 0s ease 0s; text-align: center; line-height: 60px; border-width: 0px; margin: 0px; padding: 0px; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_3')}} </div></div></div></div>

            </div>
            <!-- 左右滑动 -->
            <div class="slide">
              <!-- LAYER NR. 21 -->
              <div class="tp-parallax-wrap-line left" style="position: absolute; display: block; visibility: visible; left: 93px; top: 343px; z-index: 8;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption Gym-Subline   tp-resizeme" id="slide-14-layer-13" data-x="['left','left','left','left']" data-hoffset="['1','1','102','19']" data-y="['top','top','top','top']" data-voffset="['264','264','335','-6']" data-fontsize="['45','35','35','30']" data-letterspacing="['3','2','3','3']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:670,&quot;speed&quot;:1500,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;x:[-175%];y:0px;z:0;rX:0;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:1;&quot;,&quot;to&quot;:&quot;o:1;skX:-10px;&quot;,&quot;ease&quot;:&quot;Power3.easeOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['right','right','right','right']" data-paddingtop="[20,10,10,7]" data-paddingright="[20,20,20,20]" data-paddingbottom="[20,10,10,7]" data-paddingleft="[25,25,25,20]" style="z-index: 8; white-space: nowrap; font-size: 45px; color: rgb(255, 255, 255); letter-spacing: 3px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; background-color: rgb(0, 176, 192); font-weight: 600; visibility: inherit; transition: none 0s ease 0s; text-align: right; line-height: 30px; border-width: 0px; margin: 0px; padding: 20px 20px 20px 25px; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, -0.173648, 0.984808, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_3_Left')}} </div></div></div></div>

              <!-- LAYER NR. 20 -->
              <div class="tp-parallax-wrap-line right" style="position: absolute; display: block; visibility: visible; top: 342px; z-index: 7;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption Gym-Subline   tp-resizeme" id="slide-14-layer-5" data-x="['left','left','left','left']" data-hoffset="['771','648','292','92']" data-y="['top','top','top','top']" data-voffset="['263','263','384','45']" data-fontsize="['45','35','35','30']" data-letterspacing="['3','2','3','7']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:670,&quot;speed&quot;:1500,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;x:[175%];y:0px;z:0;rX:0;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:1;&quot;,&quot;to&quot;:&quot;o:1;skX:10px;&quot;,&quot;ease&quot;:&quot;Power3.easeOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['right','right','right','right']" data-paddingtop="[20,10,10,7]" data-paddingright="[20,20,20,20]" data-paddingbottom="[20,10,10,7]" data-paddingleft="[25,25,25,20]" style="z-index: 7; white-space: nowrap; font-size: 45px; color: rgb(255, 255, 255); letter-spacing: 3px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; background-color: rgb(0, 138, 171); font-weight: 600; visibility: inherit; transition: none 0s ease 0s; text-align: right; line-height: 30px; border-width: 0px; margin: 0px; padding: 20px 20px 20px 25px; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0.173648, 0.984808, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_3_Right')}} </div></div></div></div>
            </div>
          </div>
          </div>
         </el-carousel-item>
        <el-carousel-item>
          <img class="banner-img" src="../assets/images/home/Mainslide_1920x960_012020-05.png"/>
           <div class="banner-tip-wrapper">
          <div class="banner-tip">
            <div class="pull">
              <div class="tp-parallax-wrap " style="position: absolute; display: block; visibility: visible; left: 367px; top: 79px; z-index: 6;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption very_large_text   tp-resizeme" id="slide-14-layer-15" data-x="['center','center','center','center']" data-hoffset="['0','0','0','0']" data-y="['top','top','top','top']" data-voffset="['0','3','2','482']" data-fontsize="['45','45','40','30']" data-fontweight="['400','400','400','700']" data-letterspacing="['10','10','4','3']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:400,&quot;speed&quot;:1000,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;&quot;,&quot;to&quot;:&quot;o:1;&quot;,&quot;ease&quot;:&quot;Power4.easeInOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['center','center','center','center']" data-paddingtop="[0,0,0,0]" data-paddingright="[0,0,0,0]" data-paddingbottom="[0,0,0,0]" data-paddingleft="[0,0,0,0]" style="z-index: 6;color:#50bcd2; white-space: nowrap; font-size: 55px; font-weight: bold; letter-spacing: 10px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; visibility: inherit; transition: none 0s ease 0s; text-align: center; line-height: 60px; border-width: 0px; margin: 0px; padding: 0px; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_4')}} </div></div></div></div>

            </div>
           <div class="slide">
             
              <div class="tp-parallax-wrap-line left" style="position: absolute; display: block; visibility: visible; left: 93px; top: 343px; z-index: 8;"><div class="tp-loop-wrap" style="position:absolute;display:block;;"><div class="tp-mask-wrap" style="position: absolute; display: block; overflow: visible;"><div class="tp-caption Gym-Subline   tp-resizeme" id="slide-14-layer-13" data-x="['left','left','left','left']" data-hoffset="['1','1','102','19']" data-y="['top','top','top','top']" data-voffset="['264','264','335','-6']" data-fontsize="['45','35','35','30']" data-letterspacing="['3','2','3','3']" data-width="none" data-height="none" data-whitespace="nowrap" data-type="text" data-responsive_offset="on" data-frames="[{&quot;delay&quot;:670,&quot;speed&quot;:1500,&quot;frame&quot;:&quot;0&quot;,&quot;from&quot;:&quot;x:[-175%];y:0px;z:0;rX:0;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:1;&quot;,&quot;to&quot;:&quot;o:1;skX:-10px;&quot;,&quot;ease&quot;:&quot;Power3.easeOut&quot;},{&quot;delay&quot;:&quot;wait&quot;,&quot;speed&quot;:300,&quot;frame&quot;:&quot;999&quot;,&quot;to&quot;:&quot;opacity:0;&quot;,&quot;ease&quot;:&quot;Power3.easeInOut&quot;}]" data-textalign="['right','right','right','right']" data-paddingtop="[20,10,10,7]" data-paddingright="[20,20,20,20]" data-paddingbottom="[20,10,10,7]" data-paddingleft="[25,25,25,20]" style="z-index: 8; white-space: nowrap; font-size: 45px; color: rgb(255, 255, 255); letter-spacing: 3px; font-family: &quot;Microsoft JhengHei&quot;, sans-serif; background-color: rgb(0, 176, 192); font-weight: 600; visibility: inherit; transition: none 0s ease 0s; text-align: right; line-height: 30px; border-width: 0px; margin: 0px; padding: 20px 20px 20px 25px; min-height: 0px; min-width: 0px; max-height: none; max-width: none; opacity: 1; transform: matrix3d(1, 0, 0, 0, -0.173648, 0.984808, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); transform-origin: 50% 50% 0px;">{{$t('HomeText.BannerTip_3_Left')}} </div></div></div></div>
            </div>
          </div>
          </div>
         </el-carousel-item>
        

          
      </el-carousel>
    </div>

    <div class="gene-detection">
      <div class="title">
        <h2 style="font-weight: bold;">{{$t('HomeText.GeneticTests')}}</h2>
        <div class="short-line"></div>
      </div>

      <!-- 基因检测项目  -->
      <div class="gene-items">
        <div class="gene-item">
          <img src="../assets/images/home/home-reproductive-health.jpg"/>
          <div class="gene-item-tip">
            {{$t('HomeText.ReproductiveHealth')}}<br />
            {{$t('HomeText.ReproductiveHealth2')}}
            <a href="#/reproductinvhealth" class="a-btn">{{$t('HomeText.GeneticButton')}}</a>
          </div>
        </div>
        <div class="gene-item">
          <img src="../assets/images/home/home-cancer.jpg"/>
          <div class="gene-item-tip">
            {{$t('HomeText.Cancer')}}<br />
            {{$t('HomeText.Cancer2')}}
            <a href="/#/cancerdescript" class="a-btn">{{$t('HomeText.GeneticButton')}}</a>
          </div>
        </div>
        <div class="gene-item">
          <img src="../assets/images/home/home-infectious-disease.jpg"/>
          <div class="gene-item-tip">
            {{$t('HomeText.InfectiousDisease')}}<br />
            {{$t('HomeText.InfectiousDisease2')}}
            <a href="#/infectiousdisease" class="a-btn">{{$t('HomeText.GeneticButton')}}</a>
          </div>
        </div>
        <div class="gene-item">
          <img src="../assets/images/home/home-healthy-life.jpg"/>
          <div class="gene-item-tip">
            {{$t('HomeText.HealthyLife')}}<br />
            {{$t('HomeText.HealthyLife2')}}
            <a href="#/healthylife" class="a-btn">{{$t('HomeText.GeneticButton')}}</a>
          </div>
        </div>
      </div>

      <!-- 卓越技术 拯救生命 专业认可 值得信赖 -->
      <div class="subtitle">
        <div class="c">
          <div class="title">
            <h2 class="h2" style="font-weight: bold;">{{$t('HomeText.GeneticTestsSubtitle1')}}</h2>
            <div class="short-line"></div>
          </div>
          <p class="p">
           {{$t('HomeText.GeneticTestsSubtitle1Detail')}}<br />
           {{$t('HomeText.GeneticTestsSubtitle1Detail2')}}
          </p>
          <div class="subtitle-btn">
            <a @click="liJump('technology')" class="a-btn">{{$t('HomeText.GeneticTestsSubtitleButton')}}</a>
          </div>
        </div>
        <div class="c">
          <div class="title">
            <h2 class="h2">{{$t('HomeText.GeneticTestsSubtitle2')}}</h2>
            <div class="short-line"></div>
          </div>
          <p class="p">
            {{$t('HomeText.GeneticTestsSubtitle2Detail')}}<br />
            {{$t('HomeText.GeneticTestsSubtitle2Detail2')}}
          </p>
          <div class="subtitle-btn">
            <a @click="liJump('accreditation')" class="a-btn">{{$t('HomeText.GeneticTestsSubtitleButton')}}</a>
          </div>
        </div>
      </div>

      <!-- 服务本地诊所  处理样本数目  -->
      <div class="samples">
        <div class="c">
          <div class="value">{{clinicsCount}}</div>
          <div class="short-line"></div>
          <p>{{$t('HomeText.ServingLocalClinics')}}</p>
        </div>
        <div class="c">
          <div class="value">{{sampleCount}}</div>
          <div class="short-line"></div>
          <p>{{$t('HomeText.SamplesProcesses')}}</p>
        </div>
      </div>
    </div>

    <!-- 最新基因资讯 -->
    <div class="latest">
      <div class="title">
        <h2 style="font-weight: bold;">{{$t('HomeText.LatestGeneticInformation')}}</h2>
        <div class="short-line"></div>
      </div>
      <div class="c">
        <div class="box">
          <a @click="liJump('gensone')">
            <img src="../assets/images/gensunicerse/190927-feature-measles.jpg"/>
          </a>
          <div class="bottom">
            <a @click="liJump('gensone')" class="box-title">{{$t('GensUniverseText.gens_tip_1')}}</a>
            <div class="box-date">27 September, 2019</div>
          </div>
        </div>
        <div class="box">
          <a @click="liJump('genstwo')">
            <img src="../assets/images/gensunicerse/190730-feature-ctdna.jpg"/>
          </a>
          <div class="bottom">
            <a  @click="liJump('genstwo')" class="box-title">{{$t('GensUniverseText.gens_tip_2')}}</a>
            <div class="box-date">30 July, 2019</div>
          </div>
        </div>
        <div class="box">
          <a @click="liJump('gensthree')">
            <img src="../assets/images/gensunicerse/190725-feature-infant-food-allergy.jpg"/>
          </a>
          <div class="bottom">
            <a @click="liJump('gensthree')" class="box-title">{{$t('GensUniverseText.gens_tip_3')}}</a>
            <div class="box-date">25 July, 2019</div>
          </div>
        </div>
      </div>
    </div>


    <el-dialog
      title="公告"
      :visible.sync="dialogNoticeVisible"
      width="60%"
      :before-close="handleClose">
      <a :href="notice.FullPdfUrl" target="_blank">
        <img :src="notice.FullPdfImgUrl" width="100%" />
      </a>
    </el-dialog>
  </div>
</template>

<script>
  import {GetNewNewly} from '@/service/searchreport'
  var setHeight = function () {
    var height = $(window).height();
    var navbarHeight = $('.ct-header.navbar').height();
    $('.banners').height(height - navbarHeight)
    $('.banner-img').height(height - navbarHeight)
    $('.el-carousel__container').height(height - navbarHeight)
    console.log('setHeight', height, navbarHeight);
  }

  var scrollBg = function () {
    document.onscroll = function (e) {
      //console.log('onscroll' , e)
      var scrollTop = $(document).scrollTop(), max = 278,
        diff = scrollTop - 689;

      var top = (max - diff) * 0.5;
      top = top > max ? max : top;
      //console.log('scrollBg top', top);
      $('.samples').css('background-position', '50% ' +  top + 'px');

    }
  }

  var setBannerDelay = function () {
    let $items = $('.v-home .banners .el-carousel__item'),
      len = $items.length;

    for (let i = 0; i <len; i++) {
      let $children = $items.eq(i).find('.tp-parallax-wrap'), cLen = $children.length;
      for (let j = 0; j < cLen; j++) {
        $children.eq(j).css('transition-delay', '.' + j + 's');
      }
    }
  }


  var animation = function (e) {
    count++;
    curTop = window.scrollY;

    let $imgs = $(rootClass).find('img'), $img, imgTop, diff, len = $imgs.length;

    for (let i = 0; i < len; i++) {
      $img = $imgs.eq(i);
      imgTop = $img.offset().top;
      //console.log('animation', imgTop,  windowHeight)
      if (curTop === 0) {
        if (imgTop < windowHeight) { //首屏图片, 立刻开始动画
          $img.addClass('img-slide');
        }else{//不在第一屏的图片
          $img.removeClass('img-slide');
        }
      }
      else if (!$img.hasClass('img-slide')){
        diff = imgTop - curTop - windowHeight;
        if (diff < -10){ //误差
          $img.addClass('img-slide');
        }
      }
    }
  };
  export default {
    data() {
      return {
        clinicsCount: 0, //本地诊所数量
        sampleCount: 0, //处理样本数目
        clinicsMaxCount: 26,
        sampleMaxCount: 100000,
        notice: {},
        dialogNoticeVisible: false,
      }
    },
    mounted() {
      // if (this.isMobileDevice()) {//是手机 跳转到手机地址
        
      //     window.location.href="http://m.4008583622.net";
      // }

      setTimeout(setHeight, 200);
      scrollBg();
      setBannerDelay();

      setTimeout(()=>{
        window.onscroll = this.animation;
      }, 200);
      this.getNotice();
    },
    methods: {
      isMobileDevice(){
          let isMobile = false;
          let thisOS = navigator.platform,
              userAgent = navigator.userAgent,
              appVersion = navigator.appVersion;
          let os = ["iPhone","iPod","iPad","android","Nokia","SymbianOS","Symbian","Windows Phone","Phone","Linux armv71","MAUI","UNTRUSTED/1.0","Windows CE","BlackBerry","IEMobile"];
          for(let i=0;i<os.length;i++)
              if(thisOS.match(os[i]) || userAgent.match(os[i] || appVersion.match(os[i])))
                  isMobile = true;

          //因为相当部分的手机系统不知道信息,这里是做临时性特殊辨认
          if(navigator.platform.indexOf('iPad') != -1)
              isMobile = true;

          //做这一部分是因为Android手机的内核也是Linux
          //但是navigator.platform显示信息不尽相同情况繁多,因此从浏览器下手，即用navigator.appVersion信息做判断
          if(appVersion.match(/linux/i) )
              //X11是UC浏览器的平台 ，如果有其他特殊浏览器也可以附加上条件
              if(appVersion.match(/mobile/i) || appVersion.match(/X11/i))
                  isMobile = true;

          return isMobile;
      },
      onBannerChange(index){
        console.log('onBannerChange', index)
      },
      animation(){
        var curTop = window.scrollY,
           windowHeight = $(window).height(),
           $el = $('.samples'),
           top = $el.offset().top,
           diff = top - curTop - windowHeight;
        //console.log('animation diff, top, curTop, windowHeight', diff, top, curTop, windowHeight)
        if (diff < -120){ //误差
          this.counter();
        }
      },
      handleClose(){
        this.dialogNoticeVisible = false;
        sessionStorage.setItem('isNoticed', 'true');
      },
      async getNotice(){
        this.dialogNoticeVisible = false;
        let isNoticed = sessionStorage.getItem('isNoticed');
        if (isNoticed === "true") {
          return;
        }

        let notice = await GetNewNewly();
        if (notice) { //有公告
          notice.FullPdfImgUrl = process.env.BASE_URL + notice.PdfImgUrl;
          notice.FullPdfUrl = process.env.BASE_URL + notice.PdfUrl;
          this.notice = notice;
          this.dialogNoticeVisible = true;
        }
      },
      counter(){
        var inter = setInterval(()=>{
          if (this.clinicsCount < this.clinicsMaxCount) {
            this.clinicsCount++;
          }
          if (this.sampleCount < this.sampleMaxCount) {
            this.sampleCount+=3846;
          }
          if (this.clinicsCount >= this.clinicsMaxCount && this.sampleCount >= this.sampleMaxCount) {
            this.clinicsCount = this.clinicsMaxCount;
            this.sampleCount = this.sampleMaxCount;
            clearInterval(inter);
          }
        }, 50)

      },
       liJump(path){
            this.$router.push({
            path:path
        })
       },
    },
  }
</script>

<!-- banner 动画 -->
<style>
  .v-home .banners .el-carousel__item.is-active .banner-tip .pull .tp-parallax-wrap{
    transform: translateY(0);
  }
  .v-home .banners .el-carousel__item  .banner-tip .pull .tp-parallax-wrap{
    transform: translateY(120px);
    transition: transform .5s;
  }

  .v-home .banners .el-carousel__item.is-active .banner-tip .slide .tp-parallax-wrap-line{
    transform: translateX(0) !important;
  }
  .v-home .banners .el-carousel__item  .banner-tip .slide .left.tp-parallax-wrap-line{
    transform: translateX(-600px);
    transition: transform 1s;
  }
  .v-home .banners .el-carousel__item  .banner-tip .slide .right.tp-parallax-wrap-line{
    transform: translateX(600px);
    transition: transform 1s;
  }

  .v-home .tp-parallax-wrap-line.right{
    right: 0;
  }

  .v-home .tp-parallax-wrap-line.right .tp-mask-wrap{
    right: 93px;
  }

  .v-home .banner-tip-wrapper{
    position: absolute;
    left: 0;
    right:  0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
  }
  .v-home .banner-tip{
    position: relative;
    width: 1423px;
    height: 662px;
    margin: 0 auto;
  }
  .v-home .pull{
    position: relative;
  }
  .v-home .slide{
    position: relative;
  }

</style>
<style>
  .v-home .banners .el-carousel {
    height: 100%;
  }

  .v-home .banners .el-carousel__container {
    height: 100%;
  }

  .v-home .banners .el-carousel__item {
    height: 100%;
  }

  .tp-caption.very_large_text, .very_large_text{
    color: #fff;
    border-style: none;
    position: absolute;
    text-shadow: 0px 2px 5px rgba(0,0,0,0.5);
  }
</style>
<style scoped lang="scss">
  .v-home {
    .short-line{
      margin: 10px auto 30px;
      background-color: #51cedd;
      height: 2px;
      position: relative;
      width: 22px;
      display: block;
    }
    .banners {
      .banner-img {
        height: 100% !important;
        width: 100%;
      }
    }
    .gene-detection{
      padding-top: 60px;
      .title{
        color: #368da7;
        font-size: 28px;
        font-style: normal;
        font-weight: bold;
        text-transform: none;
      }

      .gene-items{
        display: flex;
        width: 100%;
        cursor: pointer;
        .gene-item{
          position: relative;;
          .gene-item-tip{
            transition: opacity .5s;
            opacity: 0;
            color: white;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            letter-spacing: 3px;
            .a-btn{
              margin-top: 20px;
              letter-spacing: 3px;
              color: rgb(255, 255, 255);
              &:hover{
                border-color: rgb(255, 255, 255);
                background-color: rgb(255, 255, 255);
              }
            }
          }
          img{
            width: 100%;
          }
        }

        &>:hover .gene-item-tip{
          opacity: .9;
        }
        &>:first-child .gene-item-tip{
          background-color: rgba(230,153,178,0.9);
        }
        &>:first-child .gene-item-tip .a-btn{
          border-color: rgb(203, 52, 57);
          background-color: rgb(203, 52, 57);
          &:hover{
            color: rgb(203, 52, 57);
          }
        }
        &>:nth-child(2) .gene-item-tip{
          background-color: rgba(84,108,151,0.9)
        }
        &>:nth-child(2) .gene-item-tip .a-btn{
          border-color: rgb(36, 75, 107);
          background-color: rgb(36, 75, 107);
          &:hover{
            color: rgb(36, 75, 107);
          }
        }
        &>:nth-child(3) .gene-item-tip{
          background-color: rgba(94,195,181,0.9)
        }
        &>:nth-child(3) .gene-item-tip .a-btn{
          border-color: rgb(21, 134, 125);
          background-color: rgb(21, 134, 125);
          &:hover{
            color: rgb(21, 134, 125);
          }
        }
        &>:nth-child(4) .gene-item-tip{
          background-color: rgba(241,196,128,0.9)
        }
        &>:nth-child(4) .gene-item-tip .a-btn{
          border-color: rgb(239, 104, 47);
          background-color: rgb(239, 104, 47);
          &:hover{
            color: rgb(239, 104, 47);
          }
        }
      }

      .subtitle{
        display: flex;
        background-color: rgba(54,141,167,0.15);
        padding: 60px 10%;
        text-align: center;
        p{
          color: #3a3a3a;
          font-size: 16px;
          line-height: 24px;
          font-style: normal;
          font-weight: 400;
        }
        .c{
          width: 50%;
          .subtitle-btn{
            margin-top: 30px;
          }
        }
      }

      .samples{
        height: 300px;
        background-image: url("../assets/images/home/Counter_1920x800-01.jpg");
        background-position: 50% 300px;
        font-size: 16px;
        font-weight: 700;
        color: #ffffff;
        letter-spacing: 1px;
        display: flex;
        padding: 60px;
        .c{
          width:50%;
          .short-line{
            background-color: #fff;
            margin-bottom: 12px;
          }
          .value{
            font-size: 72px;
            font-weight: 900;
          }
        }
      }
    }

    .latest{
      padding-top: 60px;
      padding-bottom: 30px;
      width: 1200px;
      margin: 0 auto;
      .title{
        color: #368da7;
        font-size: 28px;
        font-style: normal;
        font-weight: bold;
        text-transform: none;
      }
      .c{
        display: flex;
        .box{
          width: 32%;
          margin-right: 2%;
          img{
            width: 100%;
            height: auto;
          }
          .bottom{
            padding: 19px 20px 10px;
            margin-bottom: 10px;
            text-align: left;
            line-height: 27px;
            .box-title{
              font-size: 18px;
              font-style: normal;
              font-weight: 600;
              text-transform: none;
              color: #368da7;
            }

            .box-date{
              color: #3b3b3b;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/home.vue